function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.419 16.238H8.496L7.203 19.7H5.44L11.1 5.3h1.738l5.66 14.4h-1.764l-1.315-3.462zm-3.45-9.23L9.148 14.53h5.643l-2.822-7.524z",
  fill: "currentColor"
});

function SvgSingleLineTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgSingleLineTextIcon;